import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import {
  Field,
  InjectedFormProps,
  formValueSelector,
  reduxForm,
} from "redux-form";
import * as Validator from "../../../../../util/validation";
import { AppState } from "../../../../store/app_state";

import { Client } from "../../../../../domain/model/client";

import { FileWithPreview } from "react-dropzone";
import { frontEndConfig } from "../../../../../config/config";

import GoldLink from "src/presentation/common/atom/btn/gold_link";
import styled from "styled-components";
import { clientConfig } from "../../../../../config/language/ja-JP/domain/model_text";
import BtnCorporateLarge from "../../../../common/atom/btn/btn_corporate_large";
import StyledAvatarDropZone from "../../../../common/atom/drop_zone/styled_avatar_drop_zone";
import ErrorText from "../../../../common/atom/text/error_text";
import FormFieldWrapper from "../../../../common/atom/wrapper/form_field_wrapper";
import CancelButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/cancel_button_wrapper";
import SubmitButtonWrapper from "../../../../common/atom/wrapper/submit_btn_wrapper/submit_btn_wrapper";
import SubmitErrorTextWrapper from "../../../../common/atom/wrapper/submit_error_text_wrapper";
import FormGroupInputConnectRf from "../../../../common/molecular/form_group/form_group_input_connect_rf";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

interface IStateProps {
  initialValues:
    | {
        client: Client | null;
        iconURLFileObject?: File;
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {}

interface IState {
  imageError: string | null;
}

export class ClientMypageMainClientForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {
      imageError: null,
    };

    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.componentWillUpdate = this.componentWillUpdate.bind(this);
  }

  public componentWillUpdate(nextProps: any, nextState: any): void {
    // 更新実行後の初期化処理
    if (
      this.props.formValues != null &&
      this.props.initialValues.client &&
      nextProps.initialValues.client.gsIconURL !==
        this.props.initialValues.client.gsIconURL
    ) {
      URL.revokeObjectURL(this.props.formValues.preview);
      this.props.change("iconURLFileObject", null);
    }
  }

  public componentWillUnmount(): void {
    // Make sure to revoke the data uris to avoid memory leaks
    if (this.props.formValues != null) {
      URL.revokeObjectURL(this.props.formValues.preview);
    }
  }

  public render(): JSX.Element {
    const { anyTouched, invalid, handleSubmit, pristine, submitting } =
      this.props;

    const client: Client | null = this.props.initialValues
      ? this.props.initialValues.client
      : null;

    if (!client) {
      return <div>データがありません</div>;
    }

    let res: JSX.Element;

    const iconURL: string = client.getIconURL();
    const updateIconURL: string | null = this.props.formValues
      ? this.props.formValues.preview
      : null;

    // 編集ページ
    res = (
      <React.Fragment>
        <form name="ClientMypageMainClientForm" onSubmit={handleSubmit}>
          <StyledAvatarDropZone
            name="ClientMypageMainClientForm-dropzone"
            handleOnDrop={this.handleOnDrop}
            updateIconURL={updateIconURL}
            iconURL={iconURL}
          />

          <FormFieldWrapper>
            <Field
              label={clientConfig.name}
              placeholder="入力してください"
              name="client.name"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.clientName, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={clientConfig.nameKana}
              placeholder="入力してください"
              name="client.nameKana"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.clientNameKana, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={"部署"}
              placeholder="入力してください"
              name="client.department"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.title, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={clientConfig.position}
              placeholder="入力してください"
              name="client.position"
              component={FormGroupInputConnectRf}
              type="text"
              validate={[Validator.title, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          <FormFieldWrapper>
            <Field
              label={clientConfig.phoneNumber}
              placeholder="入力してください"
              name="client.phoneNumber"
              component={FormGroupInputConnectRf}
              type="tell"
              validate={[Validator.phoneNumber, Validator.required]}
              require={true}
            />
          </FormFieldWrapper>
          {anyTouched && invalid && (
            <SubmitErrorTextWrapper>
              <ErrorText>入力を完了してください</ErrorText>
            </SubmitErrorTextWrapper>
          )}

          <SubmitButtonWrapper>
            <CancelButtonWrapper>
              <CancelLink to="/client/mypage/client">キャンセル</CancelLink>
            </CancelButtonWrapper>
            <BtnCorporateLarge
              name="ClientMypageMainClientForm-submit"
              type="submit"
              widthSize="200px"
              disabled={pristine || submitting || invalid}
            >
              変更を保存
            </BtnCorporateLarge>
          </SubmitButtonWrapper>
        </form>
      </React.Fragment>
    );

    return res;
  }

  private handleOnDrop(
    acceptedFiles: FileWithPreview[],
    rejectedFiles: FileWithPreview[]
  ): void {
    try {
      this.setState({ imageError: null });

      if (rejectedFiles.length > 1) {
        throw new Error("複数のファイルが選択されました");
      } else if (
        rejectedFiles.length > 0 &&
        rejectedFiles[0].size > uploadFileMaxSize
      ) {
        throw new Error("ファイルサイズオーバ");
      } else {
        this.props.change("iconURLFileObject", acceptedFiles[0]);
      }
    } catch (error) {
      this.setState({ imageError: error.message });
    }
  }
}

const selector = formValueSelector("ClientMypageMainClientForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValues: selector(state, "iconURLFileObject"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "ClientMypageMainClientForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientMypageMainClientForm));

const CancelLink = styled(GoldLink)`
  font-size: 12px;
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/mypage/edit_client/client_mypage_main_client_form.tsx